import useSWR from 'swr';
import useSWRImmutable from 'swr/immutable';

import {request} from '../request';

export type DeploymentEnvironmentParametersRequest = {
  latest?: boolean;
  projectId?: string;
  applicationId?: string;
};

export type DeploymentEnvironmentParametersResponse = Record<string, string>;

export const EnvironmentParametersPath = '/gsp/environment';

/**
 * This function retrieves the environment parameters for a deployment.
 */
export async function getDeploymentEnvironmentParameters(
  params: DeploymentEnvironmentParametersRequest
) {
  const response = await request<DeploymentEnvironmentParametersResponse>({
    params,
    method: 'get',
    url: EnvironmentParametersPath,
  });

  return response.body;
}

type UseDeploymentEnvironmentParameters = DeploymentEnvironmentParametersRequest & {
  avoidFetch?: boolean;
};

export function useDeploymentEnvironmentParameters({
  avoidFetch = false,
  ...data
}: UseDeploymentEnvironmentParameters) {
  const shouldFetch = !avoidFetch && data.projectId && data.applicationId;

  return useSWR(
    shouldFetch
      ? `${EnvironmentParametersPath}-latest-${data.latest}-${data.projectId}`
      : null,
    async () => await getDeploymentEnvironmentParameters(data),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
}

export function useDeploymentDefaultEnvironmentParameters({
  avoidFetch = false,
  ...data
}: UseDeploymentEnvironmentParameters) {
  const shouldFetch = !avoidFetch && data.projectId && data.applicationId;

  return useSWRImmutable(
    shouldFetch
      ? `${EnvironmentParametersPath}/default-parameters-${data.projectId}`
      : null,
    async () =>
      await getDeploymentEnvironmentParameters({
        ...data,
        latest: false,
      }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
}
